import React from "react";
import { TextInput, Create, SimpleForm, required } from "react-admin";
import { getPageId } from "../../helpers/getPageId";
import ColorPickerField from "./ColorPickerField";

const VariantCreate = (props) => {
  const pageId = getPageId();

  return (
    <Create {...props} permissions="Seller" redirect="list">
      <SimpleForm defaultValues={{ page: pageId }}>
        <TextInput source="label" validate={required()} />
        <TextInput multiline source="description" validate={required()} />
        <ColorPickerField source="colorCode" label="Color code" />
      </SimpleForm>
    </Create>
  );
};

export default VariantCreate;
